import { initializeApp, getApp, getApps, FirebaseApp } from 'firebase/app';

interface FirebaseConfig {
  FCM_API_KEY: string;
  FCM_AUTH_DOMAIN: string;
  FCM_DATABASE_URL: string;
  FCM_PROJECT_ID: string;
  FCM_STORAGE_BUCKET: string;
  FCM_MESSAGING_SENDER_ID: string;
  FCM_APP_ID: string;
  FCM_MESUREMENT_ID: string;
}

export default class FirebaseManager {
  static instance: FirebaseApp;

  static getInstance(firebaseConfig?: FirebaseConfig) {
    if (!this.instance) {
      this.instance = FirebaseManager.getApp(firebaseConfig);
    }
    return this.instance;
  }

  static getApp(firebaseConfig?: FirebaseConfig) {
    if (!getApps().length) {
      let FCM_API_KEY = 'AIzaSyCZnFc7Ea4BLfGTa044z3oYkuSD5UF2KuE',
        FCM_AUTH_DOMAIN = 'api-project-317780763450.firebaseapp.com',
        FCM_DATABASE_URL = 'https://api-project-317780763450.firebaseio.com',
        FCM_PROJECT_ID = 'api-project-317780763450',
        FCM_STORAGE_BUCKET = 'api-project-317780763450.appspot.com',
        FCM_MESSAGING_SENDER_ID = '317780763450',
        FCM_APP_ID = '1:317780763450:web:be60c3cf7662af679e6603',
        FCM_MESUREMENT_ID = 'G-XWYHJRQYMY';
      if (firebaseConfig && typeof firebaseConfig === 'object') {
        ({
          FCM_API_KEY = 'AIzaSyCZnFc7Ea4BLfGTa044z3oYkuSD5UF2KuE',
          FCM_AUTH_DOMAIN = 'api-project-317780763450.firebaseapp.com',
          FCM_DATABASE_URL = 'https://api-project-317780763450.firebaseio.com',
          FCM_PROJECT_ID = 'api-project-317780763450',
          FCM_STORAGE_BUCKET = 'api-project-317780763450.appspot.com',
          FCM_MESSAGING_SENDER_ID = '317780763450',
          FCM_APP_ID = '1:317780763450:web:be60c3cf7662af679e6603',
          FCM_MESUREMENT_ID = 'G-XWYHJRQYMY',
        } = firebaseConfig);
      }
      const app = initializeApp({
        apiKey: FCM_API_KEY,
        authDomain: FCM_AUTH_DOMAIN,
        databaseURL: FCM_DATABASE_URL,
        projectId: FCM_PROJECT_ID,
        storageBucket: FCM_STORAGE_BUCKET,
        messagingSenderId: FCM_MESSAGING_SENDER_ID,
        appId: FCM_APP_ID,
        measurementId: FCM_MESUREMENT_ID,
      });
      return app;
    } else {
      return getApp();
    }
  }
}